import { useEffect, useState } from 'react';

interface WebviewGlobals {
  isReady: boolean;
  accountId: string;
  authToken: string;
  pxHeaders: string;
  featureFlags: string;
}

export function useWebviewHelper(): WebviewGlobals {
  const [state, setState] = useState<WebviewGlobals>({
    isReady: false,
    accountId: '',
    authToken: '',
    pxHeaders: '',
    featureFlags: '',
  });

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const handler = () => {
      clearTimeout(timeout);
      setState({
        isReady: true,
        accountId: window.__AccountID || '',
        authToken: window.__AuthToken || '',
        pxHeaders: window.__pxHeaders || '',
        featureFlags: window.__FeatureFlags || '',
      });
    };

    document.addEventListener('InjectedGlobalsReady', handler);

    // Support backward compatibility
    if (
      window.__AccountID ||
      window.__AuthToken ||
      window.__pxHeaders ||
      window.__FeatureFlags
    ) {
      handler();
    } else {
      timeout = setTimeout(() => {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'APP_CONNECTION_FAILED' }));
        }
      }, 5000);
    }

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('InjectedGlobalsReady', handler);
    };
  }, []);

  return state;
}
